import { Button, Card, Col, Form, Input, Row, Typography } from "antd";

import { Fragment, useState } from "react";
import { useDispatch } from "react-redux";
import { addDesignation } from "../../redux/actions/designation/addDesignationAciton";
import UploadMany from "../Card/UploadMany";
import styles from "./AddDesignation.module.css";

const AddDesignation = ({ onSuccess = null, inModal = false, onCancel = null }) => {
  const dispatch = useDispatch();
  const { Title } = Typography;
  const showCancel = Boolean(onCancel);

  const [loader, setLoader] = useState(false);
  const [form] = Form.useForm();

  const onFinish = async (values) => {
    try {
      const resp = await dispatch(addDesignation(values));
      if (resp === "success") {
        setLoader(false);
        form.resetFields();
        if (inModal && onSuccess) onSuccess();
      } else {
        setLoader(false);
      }
    } catch (error) {
      setLoader(false);
      console.log(error.message);
    }
  };

  const onFinishFailed = (errorInfo) => {
    setLoader(false);
    console.log("Failed:", errorInfo);
  };

  const formContent = (
    <Form
      form={form}
      name="basic"
      labelCol={{ span: inModal ? 6 : 7 }}
      wrapperCol={{ span: inModal ? 18 : 16 }}
      initialValues={{ remember: true }}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
      autoComplete="off"
    >
      <Form.Item
        style={{ marginBottom: "10px" }}
        label="Name"
        name="name"
        rules={[{ required: true, message: "Please input designation name!" }]}
      >
        <Input />
      </Form.Item>
      <Form.Item
        style={{ marginBottom: inModal ? 0 : "10px" }}
        className={!inModal ? styles.addDesignationBtnContainer : undefined}
        wrapperCol={inModal ? { offset: 0, span: 24 } : undefined}
      >
        {inModal ? (
          <div style={{ display: "flex", justifyContent: "center", gap: 8, width: "100%" }}>
            <Button
              onClick={() => setLoader(true)}
              type="primary"
              htmlType="submit"
              shape="round"
              loading={loader}
              style={{
                backgroundColor: "#52c41a",
                borderColor: "#52c41a",
                color: "#fff",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                textAlign: "center",
              }}
              block={!showCancel}
            >
              Add designation
            </Button>
            {onCancel && (
              <Button
                type="primary"
                danger
                shape="round"
                onClick={onCancel}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  textAlign: "center",
                }}
              >
                Cancel
              </Button>
            )}
          </div>
        ) : (
          <Button
            onClick={() => setLoader(true)}
            type="primary"
            htmlType="submit"
            shape="round"
            loading={loader}
          >
            Add designation
          </Button>
        )}
      </Form.Item>
    </Form>
  );

  if (inModal) return formContent;

  return (
    <Fragment>
      <Row className="mr-top" justify="space-between" gutter={[0, 30]}>
        <Col xs={24} sm={24} md={24} lg={10} xl={10} className="rounded column-design">
          <Card bordered={false}>
            <Title level={4} className="text-center" style={{ backgroundColor: "#dadada", padding: "10px", margin: "0 !important" }}>
              Add designation
            </Title>
            {formContent}
          </Card>
        </Col>
        <Col xs={24} sm={24} md={24} lg={11} xl={11} className="rounded column-design">
          <Card bordered={false} className={styles.importCsvCard}>
            <Title level={4} className="m-2 text-center">
              Import From CSV
            </Title>
            <UploadMany urlPath={"designation"} />
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default AddDesignation;
